import { FontIcon, Text, Panel, PanelType, Stack, ProgressIndicator, MessageBar, useTheme, mergeStyles, Pivot, PivotItem, Label, MessageBarType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IEventItem } from '../../../Models/Event/IEventItem';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IUserProfile } from '../../../Models/Profile/IUserProfile';
import { IAppStore } from '../../../Stores/IAppStore';
import { AttendeeRegistrationList } from '../Events/Events/AttendeeRegistrationList/AttendeeRegistrationList';
import EventSchedulesList from '../Events/EventSchedules/EventSchedulesList/EventSchedulesList';
import { TeachersList } from '../Events/Teachers/TeachersList/TeachersList';
import { TeacherAttendeeList } from './TeacherAttendeeList';
import * as Services from '../../../Services/Services';
import { IEventForTeachers } from '../../../Models/Event/IEventForTeachers';
import { IEventApi } from '../../../Services/API/Event/IEventApi';

interface ITeacherEventDetailProps {
    item: IEventItem;
    isOpen: boolean;
    close: () => void;
    profile: IUserProfile;
}


export const TeacherEventDetail: React.FunctionComponent<ITeacherEventDetailProps> = (props) => {
    const [isLoading, setIsLoading] = useBoolean(false)
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [event, setEvent] = React.useState<IEventForTeachers>();

    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });

    React.useEffect(() => {
        if (props.item.id != 0) {
            loadData();
        }
    }, [props.item])


    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const eventAttendee = await eventApi.getEventForTeachers(props.item.id)

        if (eventAttendee.isSuccess && eventAttendee.data) {
            setStatusMessage({ message: eventAttendee.message, type: MessageBarType.success });
            setEvent(eventAttendee.data);
        }
        else {
            setStatusMessage({ message: eventAttendee.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();

    }



    return (<>
        {props.isOpen ?
            <Panel
                isOpen={props.isOpen}
                onDismiss={props.close}
                type={PanelType.medium}
                isBlocking={false}
                closeButtonAriaLabel="Zavřít">
                <Stack>
                    <Stack horizontal>
                        <Stack horizontalAlign='end' styles={{ root: { width: 80 } }}>
                            <FontIcon iconName="Event" className={iconClass} />
                        </Stack>

                        <Stack horizontal verticalAlign="center">
                            <Text styles={{ root: { fontWeight: 600 } }} variant="xLarge">
                                {props.item.name}
                            </Text>
                        </Stack>
                    </Stack>
                    <Pivot aria-label="Akce">
                        <PivotItem
                            headerText="Přihlášení žáci"
                            headerButtonProps={{
                                'data-order': 1,
                                'data-title': 'Přihlášení žáci',
                            }}>
                            <Stack>
                                <TeacherAttendeeList event={event} />
                            </Stack>
                        </PivotItem>
                        <PivotItem
                            headerText="Lekce / docházka"
                            headerButtonProps={{
                                'data-order': 1,
                                'data-title': 'Lekce',
                            }}>
                            <EventSchedulesList eventId={props.item.id} lessonLength={event?.lessonLength} numberOfLessons={event?.numberOfLessons} />
                        </PivotItem>
                    </Pivot>

                    <Stack styles={{ root: { height: 10 } }}>
                        {isLoading ? <ProgressIndicator /> : null}
                    </Stack>
                    {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
                </Stack>
            </Panel> : null}
    </>)
}

const TeacherEventDetailToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,


});

const TeacherEventDetailDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({

});

export default connect(TeacherEventDetailToProps, TeacherEventDetailDispatchToProps)(TeacherEventDetail);

